export const popularMovies = [
  {
    Title: 'Avengers: Endgame',
    Year: '2019',
    Rated: 'PG-13',
    Released: '26 Apr 2019',
    Runtime: '181 min',
    Genre: 'Action, Adventure, Drama',
    Director: 'Anthony Russo, Joe Russo',
    Writer: 'Christopher Markus, Stephen McFeely, Stan Lee',
    Actors: 'Robert Downey Jr., Chris Evans, Mark Ruffalo',
    Plot: "After the devastating events of Avengers: Infinity War (2018), the universe is in ruins. With the help of remaining allies, the Avengers assemble once more in order to reverse Thanos' actions and restore balance to the universe.",
    Language: 'English, Japanese, Xhosa, German',
    Country: 'United States',
    Awards: 'Nominated for 1 Oscar. 70 wins & 133 nominations total',
    Poster:
      'https://m.media-amazon.com/images/M/MV5BMTc5MDE2ODcwNV5BMl5BanBnXkFtZTgwMzI2NzQ2NzM@._V1_SX300.jpg',
    Ratings: [
      {
        Source: 'Internet Movie Database',
        Value: '8.4/10',
      },
      {
        Source: 'Rotten Tomatoes',
        Value: '94%',
      },
      {
        Source: 'Metacritic',
        Value: '78/100',
      },
    ],
    Metascore: '78',
    imdbRating: '8.4',
    imdbVotes: '1,246,637',
    imdbID: 'tt4154796',
    Type: 'movie',
    DVD: '30 Jul 2019',
    BoxOffice: '$858,373,000',
    Production: 'N/A',
    Website: 'N/A',
    Response: 'True',
  },
  {
    Title: 'Interstellar',
    Year: '2014',
    Rated: 'PG-13',
    Released: '07 Nov 2014',
    Runtime: '169 min',
    Genre: 'Adventure, Drama, Sci-Fi',
    Director: 'Christopher Nolan',
    Writer: 'Jonathan Nolan, Christopher Nolan',
    Actors: 'Matthew McConaughey, Anne Hathaway, Jessica Chastain',
    Plot: 'When Earth becomes uninhabitable in the future, a farmer and ex-NASA pilot, Joseph Cooper, is tasked to pilot a spacecraft, along with a team of researchers, to find a new planet for humans.',
    Language: 'English',
    Country: 'United States, United Kingdom, Canada',
    Awards: 'Won 1 Oscar. 44 wins & 148 nominations total',
    Poster:
      'https://m.media-amazon.com/images/M/MV5BZjdkOTU3MDktN2IxOS00OGEyLWFmMjktY2FiMmZkNWIyODZiXkEyXkFqcGdeQXVyMTMxODk2OTU@._V1_SX300.jpg',
    Ratings: [
      { Source: 'Internet Movie Database', Value: '8.7/10' },
      { Source: 'Rotten Tomatoes', Value: '73%' },
      { Source: 'Metacritic', Value: '74/100' },
    ],
    Metascore: '74',
    imdbRating: '8.7',
    imdbVotes: '2,053,873',
    imdbID: 'tt0816692',
    Type: 'movie',
    DVD: '24 May 2016',
    BoxOffice: '$188,020,017',
    Production: 'N/A',
    Website: 'N/A',
    Response: 'True',
  },
  {
    Title: 'The Batman',
    Year: '2022',
    Rated: 'PG-13',
    Released: '04 Mar 2022',
    Runtime: '176 min',
    Genre: 'Action, Crime, Drama',
    Director: 'Matt Reeves',
    Writer: 'Matt Reeves, Peter Craig, Bob Kane',
    Actors: 'Robert Pattinson, Zoë Kravitz, Jeffrey Wright',
    Plot: "When a sadistic serial killer begins murdering key political figures in Gotham, Batman is forced to investigate the city's hidden corruption and question his family's involvement.",
    Language: 'English, Spanish, Latin, Italian',
    Country: 'United States',
    Awards: 'Nominated for 3 Oscars. 38 wins & 181 nominations total',
    Poster:
      'https://m.media-amazon.com/images/M/MV5BM2MyNTAwZGEtNTAxNC00ODVjLTgzZjUtYmU0YjAzNmQyZDEwXkEyXkFqcGdeQXVyNDc2NTg3NzA@._V1_SX300.jpg',
    Ratings: [
      { Source: 'Internet Movie Database', Value: '7.8/10' },
      { Source: 'Rotten Tomatoes', Value: '85%' },
      { Source: 'Metacritic', Value: '72/100' },
    ],
    Metascore: '72',
    imdbRating: '7.8',
    imdbVotes: '772,360',
    imdbID: 'tt1877830',
    Type: 'movie',
    DVD: '19 Apr 2022',
    BoxOffice: '$369,345,583',
    Production: 'N/A',
    Website: 'N/A',
    Response: 'True',
  },
  {
    Title: 'Avatar',
    Year: '2009',
    Rated: 'PG-13',
    Released: '18 Dec 2009',
    Runtime: '162 min',
    Genre: 'Action, Adventure, Fantasy',
    Director: 'James Cameron',
    Writer: 'James Cameron',
    Actors: 'Sam Worthington, Zoe Saldana, Sigourney Weaver',
    Plot: 'A paraplegic Marine dispatched to the moon Pandora on a unique mission becomes torn between following his orders and protecting the world he feels is his home.',
    Language: 'English, Spanish',
    Country: 'United States',
    Awards: 'Won 3 Oscars. 90 wins & 131 nominations total',
    Poster:
      'https://m.media-amazon.com/images/M/MV5BZDA0OGQxNTItMDZkMC00N2UyLTg3MzMtYTJmNjg3Nzk5MzRiXkEyXkFqcGdeQXVyMjUzOTY1NTc@._V1_SX300.jpg',
    Ratings: [
      { Source: 'Internet Movie Database', Value: '7.9/10' },
      { Source: 'Rotten Tomatoes', Value: '82%' },
      { Source: 'Metacritic', Value: '83/100' },
    ],
    Metascore: '83',
    imdbRating: '7.9',
    imdbVotes: '1,374,723',
    imdbID: 'tt0499549',
    Type: 'movie',
    DVD: '10 Feb 2016',
    BoxOffice: '$785,221,649',
    Production: 'N/A',
    Website: 'N/A',
    Response: 'True',
  },
  {
    Title: 'Avengers: Infinity War',
    Year: '2018',
    Rated: 'PG-13',
    Released: '27 Apr 2018',
    Runtime: '149 min',
    Genre: 'Action, Adventure, Sci-Fi',
    Director: 'Anthony Russo, Joe Russo',
    Writer: 'Christopher Markus, Stephen McFeely, Stan Lee',
    Actors: 'Robert Downey Jr., Chris Hemsworth, Mark Ruffalo',
    Plot: 'The Avengers and their allies must be willing to sacrifice all in an attempt to defeat the powerful Thanos before his blitz of devastation and ruin puts an end to the universe.',
    Language: 'English',
    Country: 'United States, Norway',
    Awards: 'Nominated for 1 Oscar. 46 wins & 80 nominations total',
    Poster:
      'https://m.media-amazon.com/images/M/MV5BMjMxNjY2MDU1OV5BMl5BanBnXkFtZTgwNzY1MTUwNTM@._V1_SX300.jpg',
    Ratings: [
      { Source: 'Internet Movie Database', Value: '8.4/10' },
      { Source: 'Rotten Tomatoes', Value: '85%' },
      { Source: 'Metacritic', Value: '68/100' },
    ],
    Metascore: '68',
    imdbRating: '8.4',
    imdbVotes: '1,185,266',
    imdbID: 'tt4154756',
    Type: 'movie',
    DVD: '31 Jul 2018',
    BoxOffice: '$678,815,482',
    Production: 'N/A',
    Website: 'N/A',
    Response: 'True',
  },
  {
    Title: 'Deadpool',
    Year: '2016',
    Rated: 'R',
    Released: '12 Feb 2016',
    Runtime: '108 min',
    Genre: 'Action, Comedy',
    Director: 'Tim Miller',
    Writer: 'Rhett Reese, Paul Wernick',
    Actors: 'Ryan Reynolds, Morena Baccarin, T.J. Miller',
    Plot: 'A wisecracking mercenary gets experimented on and becomes immortal yet hideously scarred, and sets out to track down the man who ruined his looks.',
    Language: 'English',
    Country: 'United States',
    Awards: '29 wins & 78 nominations',
    Poster:
      'https://m.media-amazon.com/images/M/MV5BYzE5MjY1ZDgtMTkyNC00MTMyLThhMjAtZGI5OTE1NzFlZGJjXkEyXkFqcGdeQXVyNjU0OTQ0OTY@._V1_SX300.jpg',
    Ratings: [
      { Source: 'Internet Movie Database', Value: '8.0/10' },
      { Source: 'Rotten Tomatoes', Value: '85%' },
      { Source: 'Metacritic', Value: '65/100' },
    ],
    Metascore: '65',
    imdbRating: '8.0',
    imdbVotes: '1,110,155',
    imdbID: 'tt1431045',
    Type: 'movie',
    DVD: '21 Apr 2016',
    BoxOffice: '$363,070,709',
    Production: 'N/A',
    Website: 'N/A',
    Response: 'True',
  },
];

export const popularSeries = [
  {
    Title: 'Game of Thrones',
    Year: '2011–2019',
    Rated: 'TV-MA',
    Released: '17 Apr 2011',
    Runtime: '57 min',
    Genre: 'Action, Adventure, Drama',
    Director: 'N/A',
    Writer: 'David Benioff, D.B. Weiss',
    Actors: 'Emilia Clarke, Peter Dinklage, Kit Harington',
    Plot: 'Nine noble families fight for control over the lands of Westeros, while an ancient enemy returns after being dormant for a millennia.',
    Language: 'English',
    Country: 'United States, United Kingdom',
    Awards: 'Won 59 Primetime Emmys. 389 wins & 636 nominations total',
    Poster:
      'https://m.media-amazon.com/images/M/MV5BN2IzYzBiOTQtNGZmMi00NDI5LTgxMzMtN2EzZjA1NjhlOGMxXkEyXkFqcGdeQXVyNjAwNDUxODI@._V1_SX300.jpg',
    Ratings: [{ Source: 'Internet Movie Database', Value: '9.2/10' }],
    Metascore: 'N/A',
    imdbRating: '9.2',
    imdbVotes: '2,250,524',
    imdbID: 'tt0944947',
    Type: 'series',
    totalSeasons: '8',
    Response: 'True',
  },
  {
    Title: 'Breaking Bad',
    Year: '2008–2013',
    Rated: 'TV-MA',
    Released: '20 Jan 2008',
    Runtime: '49 min',
    Genre: 'Crime, Drama, Thriller',
    Director: 'N/A',
    Writer: 'Vince Gilligan',
    Actors: 'Bryan Cranston, Aaron Paul, Anna Gunn',
    Plot: "A chemistry teacher diagnosed with inoperable lung cancer turns to manufacturing and selling methamphetamine with a former student in order to secure his family's future.",
    Language: 'English, Spanish',
    Country: 'United States',
    Awards: 'Won 16 Primetime Emmys. 157 wins & 247 nominations total',
    Poster:
      'https://m.media-amazon.com/images/M/MV5BYmQ4YWMxYjUtNjZmYi00MDQ1LWFjMjMtNjA5ZDdiYjdiODU5XkEyXkFqcGdeQXVyMTMzNDExODE5._V1_SX300.jpg',
    Ratings: [
      { Source: 'Internet Movie Database', Value: '9.5/10' },
      { Source: 'Rotten Tomatoes', Value: '96%' },
    ],
    Metascore: 'N/A',
    imdbRating: '9.5',
    imdbVotes: '2,095,908',
    imdbID: 'tt0903747',
    Type: 'series',
    totalSeasons: '5',
    Response: 'True',
  },
  {
    Title: 'Rick and Morty',
    Year: '2013–',
    Rated: 'TV-MA',
    Released: '02 Dec 2013',
    Runtime: '23 min',
    Genre: 'Animation, Adventure, Comedy',
    Director: 'N/A',
    Writer: 'Dan Harmon, Justin Roiland',
    Actors: 'Chris Parnell, Spencer Grammer, Sarah Chalke',
    Plot: 'The fractured domestic lives of a nihilistic mad scientist and his anxious grandson are further complicated by their inter-dimensional misadventures.',
    Language: 'English',
    Country: 'United States',
    Awards: 'Won 2 Primetime Emmys. 18 wins & 43 nominations total',
    Poster:
      'https://m.media-amazon.com/images/M/MV5BZjRjOTFkOTktZWUzMi00YzMyLThkMmYtMjEwNmQyNzliYTNmXkEyXkFqcGdeQXVyNzQ1ODk3MTQ@._V1_SX300.jpg',
    Ratings: [{ Source: 'Internet Movie Database', Value: '9.1/10' }],
    Metascore: 'N/A',
    imdbRating: '9.1',
    imdbVotes: '591,730',
    imdbID: 'tt2861424',
    Type: 'series',
    totalSeasons: '8',
    Response: 'True',
  },
  {
    Title: 'The Last of Us',
    Year: '2023–',
    Rated: 'TV-MA',
    Released: '15 Jan 2023',
    Runtime: '18S min',
    Genre: 'Action, Adventure, Drama',
    Director: 'N/A',
    Writer: 'Neil Druckmann, Craig Mazin',
    Actors: 'Pedro Pascal, Bella Ramsey, Anna Torv',
    Plot: "After a global pandemic destroys civilization, a hardened survivor takes charge of a 14-year-old girl who may be humanity's last hope.",
    Language: 'English, Indonesian',
    Country: 'Canada, United States',
    Awards: 'Won 8 Primetime Emmys. 55 wins & 132 nominations total',
    Poster:
      'https://m.media-amazon.com/images/M/MV5BZGUzYTI3M2EtZmM0Yy00NGUyLWI4ODEtN2Q3ZGJlYzhhZjU3XkEyXkFqcGdeQXVyNTM0OTY1OQ@@._V1_SX300.jpg',
    Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
    Metascore: 'N/A',
    imdbRating: '8.8',
    imdbVotes: '500,224',
    imdbID: 'tt3581920',
    Type: 'series',
    totalSeasons: '2',
    Response: 'True',
  },
  {
    Title: 'Peaky Blinders',
    Year: '2013–2022',
    Rated: 'TV-MA',
    Released: '30 Sep 2014',
    Runtime: '60 min',
    Genre: 'Crime, Drama',
    Director: 'N/A',
    Writer: 'Steven Knight',
    Actors: 'Cillian Murphy, Paul Anderson, Sophie Rundle',
    Plot: 'A gangster family epic set in 1900s England, centering on a gang who sew razor blades in the peaks of their caps, and their fierce boss Tommy Shelby.',
    Language: 'English, Romanian, Irish Gaelic, Italian, Yiddish, French',
    Country: 'United Kingdom',
    Awards: 'Won 1 BAFTA Award23 wins & 55 nominations total',
    Poster:
      'https://m.media-amazon.com/images/M/MV5BZjYzZDgzMmYtYjY5Zi00YTk1LThhMDYtNjFlNzM4MTZhYzgyXkEyXkFqcGdeQXVyMTE5NDQ1MzQ3._V1_SX300.jpg',
    Ratings: [{ Source: 'Internet Movie Database', Value: '8.8/10' }],
    Metascore: 'N/A',
    imdbRating: '8.8',
    imdbVotes: '632,567',
    imdbID: 'tt2442560',
    Type: 'series',
    totalSeasons: '6',
    Response: 'True',
  },
];
